import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import { UserProvider, useUser } from './contexts/UserContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import AppRouter from './routes/AppRouter';
import AppBackground from './AppBackground';
import LearnMoreTab from './pages/LearnMore'; 
const AppContent = ({ updateAvailable, handleRefresh }) => {
  const { user } = useUser();
  const location = useLocation();
  const hideNavbar = location.pathname === '/auth' || location.pathname === '/signup';

  if (user === undefined) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'none',
          width: '100%',
        }}
      >
        <div
          style={{
            textAlign: 'center',
            color: '#1e3c72',
            fontWeight: 700,
            fontSize: 24,
          }}
        >
          Loading...
        </div>
      </div>
    );
  }

  return (
    <>
      {!hideNavbar && <Navbar />}
      <div
        className="main-content-with-footer"
        style={{ paddingTop: hideNavbar ? 0 : 60, position: 'relative', zIndex: 1 }}
      >
        <AppRouter />
        <Footer />
      </div>
    </>
  );
};

const App = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    window.addEventListener('beforeinstallprompt', (e) => {
      if (window.gtag) {
        window.gtag('event', 'pwa_install_prompt_shown');
      }
    });

    window.addEventListener('appinstalled', () => {
      if (window.gtag) {
        window.gtag('event', 'pwa_installed');
      }
    });

    if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
      navigator.serviceWorker.getRegistration().then((reg) => {
        if (reg) {
          reg.addEventListener('updatefound', () => {
            const newWorker = reg.installing;
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  window.location.reload();
                }
              });
            }
          });
        }
      });
    }
  }, []);

  const handleRefresh = () => {
    console.log('Update available!');
  };

  return (
    <UserProvider>
      <Router>
        <div className="app-root-flex">
          <AppBackground />
          <AppContent updateAvailable={updateAvailable} handleRefresh={handleRefresh} />
        </div>
      </Router>
    </UserProvider>
  );
};

export default App;
